import { Inject, Injectable, PLATFORM_ID, effect } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { GA_MEASUREMENT_ID } from '@core/token/analytics.token';
import { CookieConsentService } from '@core/service/cookie-consent.service';

@Injectable()
export class AnalyticsService {
  private loaded = false;

  get isLoaded(): boolean {
    return this.loaded;
  }

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    @Inject(GA_MEASUREMENT_ID) private readonly measurementId: string,
    private readonly cookieConsent: CookieConsentService
  ) {
    if (!isPlatformBrowser(platformId) || !measurementId) return;

    effect(() => {
      if (this.cookieConsent.categories().analytics && !this.loaded) {
        this.loadGA();
      }
    });
  }

  trackEvent(name: string, params?: Record<string, unknown>): void {
    if (!this.loaded) return;

    const win = globalThis as unknown as { gtag: (...args: unknown[]) => void };
    win.gtag('event', name, params);
  }

  private loadGA(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    const win = globalThis as unknown as { dataLayer: unknown[]; gtag: (...args: unknown[]) => void };
    win.dataLayer = win.dataLayer ?? [];
    win.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      win.dataLayer.push(arguments);
    };
    win.gtag('js', new Date());
    win.gtag('config', this.measurementId);

    this.loaded = true;
  }
}
